import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { gradientColor } from "../../../contants";

export default function StepsToByCrypto() {
  const stepsData = [
    {
      title: "Sign-Up on the Tarality platform",
      description:
        " To begin buying and selling crypto, you are required to create an account on the Tarality platform by signing up. Also, you can directly login if you have an account already on the platform.",
      img: "/assets/images/mail.png",
    },
    {
      title: "Set up your account and complete KYC.",
      description:
        "After setting your account, you can proceed with completing the KYC process on Tarality.",
      img: "/assets/images/account.png",
    },
    {
      title: " Add funds to your Tarality wallet.",
      description:
        "To add funds, simply go to your account. Click on “Deposit INR.",
      img: "/assets/images/buyFund.png",
    },
    {
      title: "Finally, buy BTC or buy crypto on Tarality.",
      description:
        "You can now easily purchase BTC tokens or any cryptocurrency using INR Deposits.",
      img: "/assets/images/trade.png",
    },
  ];

  return (
    <Box className="mainContainer" sx={{ margin: "100px 0px" }}>
      <Grid container spacing={3} alignItems={"center"}>
        <Grid item lg={6} xs={12} md={6} sm={6}>
          <Box>
            <Typography variant="h1" sx={gradientColor}>
              How to Buy Crypto
            </Typography>
          </Box>
          <Box sx={{ marginTop: "30px" }}>
            {stepsData &&
              stepsData.map((item, index, href) => {
                return (
                  <StepCard item={item} index={index} key={`xard${index}`} />
                );
              })}
          </Box>
        </Grid>
        <Grid item lg={6} xs={12} md={6} sm={6}>
          <Box className="displayEnd">
            <img
              src="/assets/images/howToBuy.png"
              alt="rgt_img"
              width="100%"
              style={{ maxWidth: "400px" }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
const StepCard = ({ item, index }) => {
  return (
    <Box className="displayStart" sx={{ padding: "20px 0px" }}>
      <Box>
        <img
          src={item.img}
          alt="tick"
          height={45}
          width={45}
          style={{ marginRight: "12px" }}
        />
      </Box>
      <Box>
        <Typography variant="h5" sx={{ color: "#FFCA65" }}>
          {item.title}
        </Typography>
        <Typography variant="body1">{item.description}</Typography>
      </Box>
    </Box>
  );
};
